'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UITruncateString = require('UIComponents/text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _AvailabilityMessage = require('../AvailabilityMessage');

var _AvailabilityMessage2 = _interopRequireDefault(_AvailabilityMessage);

var _ChatHeadingAvatars = require('./ChatHeadingAvatars');

var _ChatHeadingAvatars2 = _interopRequireDefault(_ChatHeadingAvatars);

var _getWidgetTitleText = require('../operators/getWidgetTitleText');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WidgetHeaderAvatarWrapper = function (_React$PureComponent) {
  _inherits(WidgetHeaderAvatarWrapper, _React$PureComponent);

  function WidgetHeaderAvatarWrapper() {
    _classCallCheck(this, WidgetHeaderAvatarWrapper);

    return _possibleConstructorReturn(this, (WidgetHeaderAvatarWrapper.__proto__ || Object.getPrototypeOf(WidgetHeaderAvatarWrapper)).apply(this, arguments));
  }

  _createClass(WidgetHeaderAvatarWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          availabilityMessage = _props.availabilityMessage,
          chatHeadingConfig = _props.chatHeadingConfig,
          chatHeadingResponders = _props.chatHeadingResponders,
          mobile = _props.mobile,
          showAvailabilityMessage = _props.showAvailabilityMessage,
          showStatusIndicator = _props.showStatusIndicator;


      var titleText = (0, _getWidgetTitleText.getWidgetTitleText)(chatHeadingConfig, chatHeadingResponders) || '';

      return _react2.default.createElement(
        'div',
        { className: 'widget-header-avatar-wrapper' },
        _react2.default.createElement(_ChatHeadingAvatars2.default, {
          chatHeadingConfig: chatHeadingConfig,
          chatHeadingResponders: chatHeadingResponders,
          mobile: mobile,
          showStatusIndicator: showStatusIndicator
        }),
        _react2.default.createElement(
          'h5',
          { className: 'text-center m-top-1 m-bottom-0' },
          _react2.default.createElement(
            _UITruncateString2.default,
            null,
            _react2.default.createElement(
              'span',
              {
                className: 'widget-header-name p-y-1 p-x-2',
                style: {
                  fontSize: titleText && titleText.length > 20 ? '14px' : undefined
                }
              },
              titleText
            )
          )
        ),
        showAvailabilityMessage && _react2.default.createElement(
          _AvailabilityMessage2.default,
          null,
          availabilityMessage
        )
      );
    }
  }]);

  return WidgetHeaderAvatarWrapper;
}(_react2.default.PureComponent);

WidgetHeaderAvatarWrapper.propTypes = {
  availabilityMessage: _react.PropTypes.string,
  chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
  chatHeadingResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  mobile: _react.PropTypes.bool,
  showAvailabilityMessage: _react.PropTypes.bool.isRequired,
  showStatusIndicator: _react.PropTypes.bool.isRequired
};

WidgetHeaderAvatarWrapper.defaultProps = {
  mobile: false,
  showStatusIndicator: false
};

exports.default = WidgetHeaderAvatarWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/components/WidgetHeaderAvatarWrapper.js
// module id = 1049
// module chunks = 2 3